/* Materparade: homepage, interazioni della seconda passata (parata, numeri, fisarmonica). */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };

  /* ---------- Parata: scorrimento automatico, trascinamento, pausa ---------- */
  $$('[data-mp-parade]').forEach(function (root) {
    var view = root.querySelector('[data-mp-parade-view]'), track = root.querySelector('[data-mp-parade-track]');
    var btn = root.querySelector('[data-mp-parade-toggle]');
    if (!view || !track) return;
    var items = $$('.mp-parade__item', track);
    items.forEach(function (it) { var c = it.cloneNode(true); c.setAttribute('aria-hidden', 'true'); c.tabIndex = -1; track.appendChild(c); });
    var half = function () { return track.scrollWidth / 2; };
    var paused = false, hover = false, drag = false, moved = 0, sx = 0, sl = 0, last = 0, pos = 0, SPEED = 38; /* px al secondo */
    function wrap() { var h = half(); if (view.scrollLeft >= h) view.scrollLeft -= h; else if (view.scrollLeft <= 0) view.scrollLeft += h; }
    function tick(t) {
      var dt = last ? Math.min(t - last, 60) : 16; last = t;
      if (!paused && !hover && !drag && !reduce) { pos = view.scrollLeft + SPEED * dt / 1000; view.scrollLeft = pos; wrap(); }
      requestAnimationFrame(tick);
    }
    view.scrollLeft = 1;
    requestAnimationFrame(tick);
    view.addEventListener('mouseenter', function () { hover = true; });
    view.addEventListener('mouseleave', function () { hover = false; });
    view.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; /* il dito usa lo scorrimento nativo */
      drag = true; moved = 0; sx = e.clientX; sl = view.scrollLeft; view.classList.add('is-drag');
    });
    window.addEventListener('pointermove', function (e) {
      if (!drag) return; var dx = e.clientX - sx; moved = Math.max(moved, Math.abs(dx)); view.scrollLeft = sl - dx; wrap();
    });
    window.addEventListener('pointerup', function () { if (!drag) return; drag = false; view.classList.remove('is-drag'); sl = view.scrollLeft; });
    view.addEventListener('click', function (e) { if (moved > 6) { e.preventDefault(); e.stopPropagation(); moved = 0; } }, true);
    view.addEventListener('scroll', wrap, { passive: true });
    view.addEventListener('touchstart', function () { drag = true; }, { passive: true });
    view.addEventListener('touchend', function () { setTimeout(function () { drag = false; }, 1200); }, { passive: true });
    if (btn) btn.addEventListener('click', function () {
      paused = !paused; btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      btn.setAttribute('aria-label', paused ? 'Fai ripartire la parata' : 'Metti in pausa la parata');
    });
  });

  /* ---------- Numeri: cifre che scorrono, card che seguono il mouse ---------- */
  $$('[data-mp-nums]').forEach(function (root) {
    $$('.mp-nc__value', root).forEach(function (el) {
      var n = String(parseInt(el.getAttribute('data-num'), 10) || 0), suf = el.getAttribute('data-suffix') || '';
      var html = '';
      n.split('').forEach(function (d, k) {
        var strip = ''; for (var x = 0; x < 20; x++) strip += '<i>' + (x % 10) + '</i>';
        html += '<span class="mp-d" aria-hidden="true"><span class="mp-d__strip" style="--t:' + (10 + parseInt(d, 10)) + ';--k:' + k + '">' + strip + '</span></span>';
      });
      if (suf) html += '<span class="mp-nc__suf" aria-hidden="true">' + suf + '</span>';
      el.innerHTML = html;
    });
    function enter() { root.classList.add('is-in'); setTimeout(function () { root.classList.add('is-settled'); }, 2600); }
    if (!('IntersectionObserver' in window)) enter();
    else new IntersectionObserver(function (e, o) { if (e[0].isIntersecting) { enter(); o.disconnect(); } }, { threshold: 0.3 }).observe(root);
    if (window.matchMedia && matchMedia('(hover: hover)').matches && !reduce) {
      $$('[data-mp-nc]', root).forEach(function (c) {
        c.addEventListener('pointermove', function (e) {
          var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
          c.style.setProperty('--ry', (x * 12).toFixed(2) + 'deg'); c.style.setProperty('--rx', (-y * 12).toFixed(2) + 'deg');
        });
        c.addEventListener('pointerleave', function () { c.style.setProperty('--ry', '0deg'); c.style.setProperty('--rx', '0deg'); });
      });
    }
  });

  /* ---------- Fisarmonica ---------- */
  $$('[data-mp-acc]').forEach(function (root) {
    var rows = $$('[data-mp-acc-row]', root), canHover = window.matchMedia && matchMedia('(min-width: 900px)').matches;
    function open(r) { rows.forEach(function (x) { x.classList.toggle('is-open', x === r); }); }
    rows.forEach(function (r) {
      r.addEventListener('mouseenter', function () { if (canHover) open(r); });
      r.addEventListener('focus', function () { open(r); });
      r.addEventListener('click', function (e) { if (e.target.closest('a')) return; open(r); });
      r.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(r); } });
    });
  });
})();
